// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"P0-z"};